import CoreFeaturedVideo from './CoreFeaturedVideo';

export { type CoreFeaturedVideoProps } from './CoreFeaturedVideo';
export default CoreFeaturedVideo;
